// extracted by mini-css-extract-plugin
module.exports = {"input":"_3gb2w","symbolsContainer":"_2m0dT","caret":"Ye45t","blink":"_3IyIq","value":"_1jJ_r","flasher":"_1WJyK"};